import React, { useCallback, useState } from "react";
import { Drawer, Spin } from "antd";

/**
 * 通用下钻状态钩子。统一「点开某条记录 → 抽屉展示详情 → 关闭」的交互。
 * 供风险项、KPI、航线、客户、事件等任意可下钻对象复用。
 */
export function useDrillDown() {
    const [selected, setSelected] = useState(null);
    const open = useCallback((item) => setSelected(item), []);
    const close = useCallback(() => setSelected(null), []);
    return { selected, isOpen: Boolean(selected), open, close };
}

/**
 * 通用下钻抽屉外壳：统一宽度、标题、关闭交互和加载态。
 * 详情内容通过 children 传入，各场景自行决定渲染什么。
 */
export function DrillDownDrawer({ open, title, onClose, loading = false, width = 720, extra, children }) {
    return (
        <Drawer title={title} width={width} open={open} onClose={onClose} extra={extra} destroyOnClose>
            <Spin spinning={loading}>{children}</Spin>
        </Drawer>
    );
}
